import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimsurveyPollService {

  private baseUrl = environment.urlAPI;

  constructor(private http: HttpClient) { }

  addParticipant(idPoll: string): Observable<string> {
    return this.http.post(`${this.baseUrl}RenaultPoll/AddParticipant/${idPoll}`, null, { responseType: 'text' });
  }

  hasFilledSurvey(idPoll: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}RenaultPoll/HasFilledSurvey/${idPoll}`);
  }
}
